import { loadStripe } from '@stripe/stripe-js';

const stripePromiseCache = new Map();

export const getStripePromise = (publishableKey) => {
  if (!publishableKey) {
    return Promise.resolve(null);
  }
  if (!stripePromiseCache.has(publishableKey)) {
    stripePromiseCache.set(publishableKey, loadStripe(publishableKey));
  }
  return stripePromiseCache.get(publishableKey);
};
